import React from "react";
import { ProductConsumer } from "../../../../Context/AddProWakel";
import NumberFormat from "react-number-format";

const ThirdRow = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const {
            AddProChange,
            R_del_dis,
            R_darzankartontoanotherInput,
            DarzanChange,
            R_darzan,
            R_CartonChange,
            R_nrxchange,
            R_nrx,
            R_search,
            R_karton,
            R_naweSht,
            setSaletSearchEmty,
            getProductDataBySearchRent,
            R_zhmara,
            R_toSavebyEnter,
            R_qazanj,
            R_joripara,
            R_getkoygahty,
            R_rezha,
            toanotherInput,
            createNewPage,
            R_table,
            R_open,
            R_wasl,
            saveDetail,
            R_toThirdRow,
            R_rasidKarton
          } = value;
          return (
            <>
              {/* starting 1 row */}
              <form>
                {R_search == true ? (
                  <div className="row text-warning font-weight-bold ">
                    <div className="col-sm-2"></div>
                    <div className="col-sm-1"></div>
                    <div className="col-sm-1"></div>
                    <div className="col-sm-4">
                      <h5
                        className="border b--black"
                        style={{ backgroundColor: "#32CD32", color: "#000" }}
                        name="qazanj"
                      >
                        Q$ {R_qazanj}
                      </h5>
                    </div>
                    <div className="col-sm-4">
                      <h5
                        className="border b--black"
                        style={{ backgroundColor: "#32CD32", color: "#000" }}
                        name="rasid"
                      >
                        R {R_rasidKarton}
                      </h5>
                    </div>
                  </div>
                ) : null}
                <div className="row">
                  <div className="col-sm-3 text-right mt-2">
                    <div className="form-group">
                      <label className="font-weight-bold f4">دەرزەن</label>
                      <input
                        type="text"
                        disabled={R_del_dis == true ? true : null}
                        onKeyPress={(event) =>
                          event.key == "Enter" ? R_toThirdRow(event) : null
                        }
                        onChange={(e) => DarzanChange(e)}
                        value={R_darzan == 0 ? "" : R_darzan}
                        name="R_darzan"
                        className="form-control text-right font-weight-bold pr-4"
                      />
                    </div>
                  </div>
                  <div className="col-sm-2 text-right mt-2">
                    <div className="form-group">
                      <label className="font-weight-bold f4">کارتۆن</label>
                      <input
                        type="text"
                        disabled={R_del_dis == true ? true : null}
                        onKeyPress={(event) =>
                          event.key == "Enter"
                            ? R_darzankartontoanotherInput(event)
                            : null
                        }
                        onChange={R_CartonChange}
                        value={R_karton == 0 ? "" : R_karton}
                        name="R_karton"
                        className="form-control text-right font-weight-bold pr-4"
                      />
                    </div>
                  </div>
                  <div className="col-sm-4 text-right mt-2">
                    <div className="form-group">
                      <label className="font-weight-bold f4">ناوی شتەکان</label>
                      <input
                        type="text"
                        disabled={R_del_dis == true ? true : null}
                        value={R_naweSht}
                        name="R_naweSht"
                        onKeyPress={(event) =>
                          event.key == "Enter" ? toanotherInput(event) : null
                        }
                        className="form-control text-right font-weight-bold"
                      />
                    </div>
                  </div>
                  <div className="col-sm-3 text-right mt-2">
                    <div className="form-group">
                      <label className="font-weight-bold f4">کۆد</label>
                      <input
                        type="text"
                        onClick={setSaletSearchEmty}
                        disabled={R_del_dis == true ? true : null}
                        onKeyPress={(event) =>
                          event.key == "Enter"
                            ? getProductDataBySearchRent(event)
                            : null
                        }
                        value={R_zhmara}
                        name="R_zhmara"
                        onChange={AddProChange}
                        className="form-control text-right font-weight-bold tc pr-4"
                      />
                    </div>
                  </div>
                </div>
                {/* end of 1 */}
                {/* starting 2 row */}
                <div className="row card-header p-1 border-bottom border-warning">
                  <div className="col-3 text-right px-2 mt4">
                    <button
                      onClick={createNewPage}
                      disabled={R_table == true || R_open == true ? true : null}
                      className={`btn ${
                        R_open == true || R_table == true
                          ? "btn-danger"
                          : "btn-primary"
                      } mr4 mt2`}
                    >
                      <i className="far fa-file fa-lg"></i>
                    </button>
                    <button
                      onClick={(e) => saveDetail(e, R_wasl)}
                      className="btn btn-success mt2"
                    >
                      <i className="far fa-save"></i>
                    </button>
                  </div>
                  <div className="col-sm-4 text-right ">
                    <div className="form-group ">
                      {R_joripara == "دۆلار" ? (
                        <>
                          <label className="fk">$ کۆی گشتی </label>
                          <input
                            type="number"
                            disabled={R_del_dis == true ? true : null}
                            value={
                              R_karton > 0 || R_darzan > 0
                                ? R_getkoygahty(R_darzan, R_karton)
                                : 0
                            }
                            onChange={AddProChange}
                            onKeyPress={(event) =>
                              event.key == "Enter"
                                ? saveDetail(event, R_wasl)
                                : null
                            }
                            name="R_koygshty$"
                            onChange={AddProChange}
                            className="form-control text-right font-weight-bold tc"
                          />
                        </>
                      ) : (
                        <>
                          <label className="fk">ID کۆی گشتی </label>
                          <input
                            type="number"
                            disabled={R_del_dis == true ? true : null}
                            value={
                              R_karton > 0 || R_darzan > 0
                                ? R_getkoygahty(R_darzan, R_karton)
                                : 0
                            }
                            onChange={AddProChange}
                            onKeyPress={(event) =>
                              event.key == "Enter"
                                ? saveDetail(event, R_wasl)
                                : null
                            }
                            name="R_koygshtyID"
                            onChange={AddProChange}
                            className="form-control text-right font-weight-bold tc"
                          />
                        </>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-2 text-right ">
                    <div className="form-group">
                      <label className="font-weight-bold f4">ڕێژە</label>
                      <input
                        type="number"
                        disabled={R_del_dis == true ? true : null}
                        value={R_rezha}
                        name="R_rezha"
                        className="form-control text-right font-weight-bold"
                      />
                    </div>
                  </div>
                  <div className="col-sm-3 text-right ">
                    <div className="form-group">
                      <label className="font-weight-bold f4">نرخ</label>
                      <input
                        type="text"
                        disabled={R_del_dis == true ? true : null}
                        value={R_nrx}
                        onKeyPress={(event) =>
                          event.key == "Enter" ? R_toSavebyEnter(event) : null
                        }
                        name="R_nrx"
                        onChange={R_nrxchange}
                        className="form-control text-right font-weight-bold pr-4"
                      />
                    </div>
                  </div>
                </div>
              </form>
              {/* end of 2 */}
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default ThirdRow;
